// extracted by mini-css-extract-plugin
export var contactMe = "style-module--contact-me--1nfdC";
export var starHeader = "style-module--star-header--3eKDj";
export var starBar = "style-module--star-bar--3we-j";
export var methodContainer = "style-module--method-container--3891U";
export var iconCircle = "style-module--icon-circle--19a0L";
export var container = "style-module--container--11cqo";